/**
 * Inventory zod schemas (docs/INVENTORY.md). Shared between the API's
 * request validation and the web app's forms.
 */
import { z } from 'zod';
import { idSchema, paginationSchema, qtyMilliSchema } from './common.js';
import { STOCK_REASONS } from '../constants.js';
/** A manual stock adjustment — the only place a human directly moves stock. */
export const stockAdjustmentSchema = z.object({
    shopId: idSchema,
    variantId: idSchema,
    batchId: idSchema.nullable().optional(),
    /** Signed. Positive = ADJUSTMENT_IN, negative = ADJUSTMENT_OUT (the service picks the reason). */
    qtyDeltaMilli: qtyMilliSchema.refine((v) => v !== 0, 'Quantity must not be zero'),
    reasonCode: z.enum([
        'DAMAGE_OUT',
        'EXPIRY_OUT',
        'COUNT_CORRECTION',
        'ADJUSTMENT_IN',
        'ADJUSTMENT_OUT',
    ]),
    unitCostPaisa: z.number().int().min(0).optional(),
    note: z.string().max(500).optional(),
});
export const stockLevelsQuerySchema = paginationSchema.extend({
    shopId: idSchema.optional(),
    categoryId: idSchema.optional(),
    search: z.string().max(120).optional(),
    lowStockOnly: z.coerce.boolean().optional(),
    belowZeroOnly: z.coerce.boolean().optional(),
});
export const movementHistoryQuerySchema = paginationSchema.extend({
    shopId: idSchema.optional(),
    variantId: idSchema.optional(),
    batchId: idSchema.optional(),
    reason: z.enum(STOCK_REASONS).optional(),
    refType: z.string().max(40).optional(),
    refId: idSchema.optional(),
    from: z.coerce.date().optional(),
    to: z.coerce.date().optional(),
});
export const openingStockLineSchema = z.object({
    shopId: idSchema,
    variantId: idSchema,
    qtyMilli: z.number().int().min(0),
    unitCostPaisa: z.number().int().min(0).default(0),
    batchNo: z.string().max(60).optional(),
    expiryDate: z.coerce.date().optional(),
});
export const openingStockImportSchema = z.object({
    lines: z.array(openingStockLineSchema).min(1),
});
//# sourceMappingURL=inventory.js.map